import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} startpagina`,
    languageButtonLabel: `Taal`,
    languageModalTitle: `Kies een taal`,
    languageModalCloseLabel: `Sluit taalmenu`,
  },
  languageOptions: {
    'en-US': {
      label: `Engels`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Engels (Kenia)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Engels (Nigeria)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Engels (Singapore)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Portugees`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Português (Brasil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Duits`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Deutsch (Österreich)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Deutsch (Schweiz)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Spaans`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Frans`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Italiaans`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Nederlands`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polski`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Nordisch & Baltisch`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Dansk`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Suomi`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norsk`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Íslenska`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Japans`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Koreaans`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Mandarijn`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Kantonees`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Tiếng Việt`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Thais`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Bahasa Indonesia`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Kiswahili`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Hindi`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `বাংলা`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `मराठी`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `తెలుగు`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Farsi`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `اردو`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `پنجابی`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Naijá Pidgin`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Russisch`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Arabisch`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `العربية (الإمارات)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `العربية (قطر)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Marokkaans Arabisch`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Türkçe`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Kies een taal`,
    closeLabel: `Sluit taalmenu`,
  },
  languageHint: (ctx) => `Schakel naar ${ctx.localesCount}+ taalversies.`,
  readPagePrompt: ({languageLabel}) => `Lees deze pagina in ${languageLabel}.`,
};
